<template lang="html">
    <div>
        <div class="row mx-1">
            <div class="col-12 col-sm-12 col-md-12 mb-3">
                <div class="d-flex align-items-start justify-content-between my-2">
                    <label class="full fs-large darker m-0">How would you like to set the price for this group?</label> 
                    <button class="btn-learn-more bold pointer fs-large ml-3 text-nowrap m-0" @click.prevent.stop="openLearnMoreModal">Learn More</button>
                </div>
                <div class="d-flex flex-column justify-content-between mt-3 col-12 col-sm-12 col-md-12">
                    <div class="d-flex">
                        <radio v-model="group.passengerSettings.format" @input="changePriceType" :value="1" :disabled="disabled" class="mb-1 mr-2" :class="{'notAllowed': disabled}">
                            Price per Person
                        </radio>
                        <i class="fa fa-info-circle fs-normal dark mt-1" v-tooltip="'Each person pays this amount individually, but the price depends on the number of people'"></i>
                    </div>
                    
                    <div class="d-flex">
                        <radio v-model="group.passengerSettings.format" @input="changePriceType" :value="0" :disabled="disabled" class="mb-1 mr-2" :class="{'notAllowed': disabled}">
                            Price per Group
                        </radio>
                        <i class="fa fa-info-circle fs-normal dark mt-1" v-tooltip="'The group pays this amount regardless of the number of people'"></i>
                    </div>

                    <div class="d-flex">
                        <radio v-model="group.passengerSettings.format" @input="changePriceType" :value="2" :disabled="disabled" class="mr-2" :class="{'notAllowed': disabled}">
                            Price per Category Tier
                        </radio>
                        <i class="fa fa-info-circle fs-normal dark mt-1" v-tooltip="'Each person pays this amount individually, but the price depends on the number of people per category'"></i>
                    </div>
                </div>
            </div>
        </div>
    
        <h5 class="mt-2 mb-4 p-0"></h5>
        
        <div class="row mx-1">
            <div class="col-12 col-sm-12 col-md-12">
                <table class="table narrow">
                    <thead v-if="true">
                        <tr class="thead-size">             
                            <th width="35%" class="border-top-0 border-left-0 border-bottom border-right text-center">Number of People</th>
                            <th width="30%" class="border-top-0 border-right-0 border-bottom text-center">Tax</th>
                            <th width="25%" class="border-top-0 border-right-0 border-bottom text-center">Price</th>
                            <th width="10%" class="border-top-0 border-right-0 border-bottom text-center">
                                <i class="fas fa-calculator fs-large medium pointer" :class="{'dark': hasDecomposedPrices, 'notAllowed': (disabled && !hasDecomposedPrices) || hasPriceErrorsDueResources}" v-tooltip="'Edit'" @click="openEditPrice()"></i>
                            </th>
                        </tr>
                    </thead>
                    
                    <tbody>
                        <tr v-for="priceConfig, idx in pricePerGroupPrices" :class="{'more-than-allowed': moreThanAllowed(priceConfig, idx) || hasPriceGroupDecompositionError(priceConfig)}">
                            <td class="border-right default-cursor">
                                <div class="d-flex align-items-center justify-content-center my-1">
                                    <span class="mr-3 fs-normal bold darker">{{priceConfig.lowerBound}}</span>
                                    <span class="mr-3 fs-normal darker">to</span>
                                    <input 
                                        class="text-center fs-normal" 
                                        type="number"  
                                        v-model.number="priceConfig.upperBound"
                                        style="height: 1.8rem; width: 3.2rem;"
                                        @input="debouncedUpdatePeopleNumber(idx, $event.target.valueAsNumber)"
                                        :disabled="disabled || hasPriceErrorsDueResources"/>
                                </div>
                            </td>

                            <td class="default-cursor">
                                <div class="d-flex justify-content-center align-items-center mx-2">
                                    <v-select
                                        :options="taxes"
                                        :value="getTaxValue(priceConfig.vat)"
                                        label="description"
                                        placeholder="Select tax"
                                        class="ppg-smaller-select"
                                        :class="{'pointer': !disabled || !hasPriceErrorsDueResources, 'notAllowed': disabled || hasPriceErrorsDueResources}"
                                        :disabled="disabled || hasPriceErrorsDueResources"
                                        @input="updateTaxVal($event, priceConfig)">
                                    </v-select>
                                </div>
                            </td>

                            <td class="default-cursor">
                                <div class="d-flex justify-content-center align-items-center mx-4">
                                   <input :disabled="disabled || hasPriceErrorsDueResources" class="glued-right pr-0 w-80" type="number" style="max-width: 4rem; height: 1.8rem;" v-model.number="priceConfig.price">
                                   <div class="glued-left p-1 pr-2" style="height: 1.8rem;">€</div>
                                </div>
                            </td>

                            <td class="default-cursor">
                                <div class="d-flex align-items-center" :class="{'justify-content-center': !hasDecomposedPrices, 'justify-content-between': hasDecomposedPrices}">
                                    <i class="fa fa-info-circle fs-normal darker" :class="{'color-6': hasPriceGroupDecompositionError(priceConfig)}" v-if="hasDecomposedPrices" v-tooltip="priceConfigInfo(priceConfig)"></i>
                                    <i class="ico-delete fs-large medium" :class="{'pointer': !disabled || !hasPriceErrorsDueResources, 'notAllowed': disabled || hasPriceErrorsDueResources}" v-tooltip="'Remove'" v-if="pricePerGroupPrices.length > 1 " @click="removePriceConfig(idx)"></i>
                                </div>
                            </td>
                        </tr>
    
                        <tr style="height: 40px;">
                            <td class="border-top default-cursor" :class="{'border-right': !hasPriceErrors}">
                                <div class="d-flex align-items-center" v-if="!hasPriceErrors">
                                    <div @click="addPriceConfig()" class="d-flex align-items-center bold" :class="{'pointer': !disabled || !hasPriceErrorsDueResources, 'notAllowed': disabled || hasPriceErrorsDueResources}">
                                        <i class="ico-add fs-smallest add-circle color-1"></i> Add
                                    </div>
                                 </div>
                            </td>                                              
                            <td class="border-top default-cursor"></td>
                            <td class="border-top default-cursor"></td>
                            <td class="border-top default-cursor"></td>
                        </tr>
                    </tbody>
                </table>
                
                <div v-if="!hasPriceErrors && !hasPriceErrorsDueResources" class="mt-4 ml-1 d-flex justify-content-start align-items-center">
                    <i class="fa fa-info-circle fs-large color-6 mr-2"></i>
                    <span class="mb-0 fs-small color-6 bold">{{importantNote}}</span>
                </div>

                <div v-if="hasPriceErrors && !hasPriceErrorsDueResources" class="error mt-3 d-flex justify-content-center">
                    <i class="fas fa-exclamation-triangle fs-large color-6 mr-2"></i>
                    <span class="mb-0 fs-small color-6 bold">{{priceErrorMessage}}</span>
                </div>

                <div v-if="hasPriceErrorsDueResources" class="error mt-3 d-flex justify-content-center">
                    <i class="fas fa-exclamation-triangle fs-large color-6 mr-2"></i>
                    <span class="mb-0 fs-small color-6 bold">{{resourcesPriceErrorMessage}}</span>
                </div>
            </div>
        </div>

        <h5 class="my-4 p-0"></h5>

        <div class="row mx-1">
            <div class="col-12 mb-3">
                <label class="full my-2 fs-large darker">This group includes:</label>
                <div class="row mt-3 mx-0 justify-content-between">
                    <div v-for="genderPrice, idx in audienceTypes"
                         :key="genderPrice.id"
                         class="col-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 col-xxl-3 p-0 d-flex align-items-start mb-2">

                        <div class="checkbox-component" style="display: inline-flex; align-items: center; white-space: nowrap;" :class="{'pointer': !disabled, 'notAllowed': disabled || !hasOnlyOneGenderPrice && getAudienceTypeCheckboxValue(genderPrice)}">
                            <input type="checkbox" :id="`checkbox-id-${idx}`" :checked="getAudienceTypeCheckboxValue(genderPrice)" @change="updateAudienceTypeCheckbox($event, genderPrice)" :disabled="disabled || !hasOnlyOneGenderPrice && getAudienceTypeCheckboxValue(genderPrice)"> 
                            <label :for="`checkbox-id-${idx}`">
                                <span class="input-box"><svg viewBox="0 0 16 16" class="input-box-tick"><path fill="none" d="M1.7,7.8l3.8,3.4l9-8.8"></path></svg></span>
                                {{ genderPrice.description }}
                            </label>
                        </div>
                        
                        <i class="fas fa-project-diagram fs-normal ml-2 medium mt-1 pointer" :class="{'color-1': hasPriceDependencies(genderPrice), 'notAllowed': disabled && !hasPriceDependencies(genderPrice)}" v-tooltip="'Dependencies'" v-if="validateGenderPriceDeps(genderPrice)" @click="openGenderPriceDeps(genderPrice)"></i>
                        <i class="fas fa-cog ml-1 pointer darkest fs-large" v-tooltip="'Prices'" v-if="isTierPrice(genderPrice) && group.passengerSettings.format === 2" @click="activateCategoryPrices(genderPrice)"></i>
                        <i class="fas fa-check-circle ml-1 pointer color-3 fs-smallest check-icon-position" v-if="isSameHash(genderPrice) && group.passengerSettings.format === 2"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import extendedVSelect from '@/extends/vue-select'
import { priceManagerMixin } from '@/mixins/priceManager'
import _ from 'lodash'

export default {
    data() {
        return {
            debouncedUpdatePeopleNumber: null,
            selectedHash: null,
        }
    },
    mixins: [
        priceManagerMixin
    ],
    props: {
        prices: {
            default: null
        },
        perOrderReferenceGenderPrice: {
            default: null,
        },
        hasDecomposedPrices: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        group: {
            type: Object,
            default: null
        },
        editingEvent: {
            type: Boolean,
            default: false
        }
    }, 
    watch: {
		'group.productGenderPrices': {
            deep: true,
            handler(newVal) {
                const configurations = this.group && this.group.passengerSettings && this.pricePerGroupPrices;

                if (!configurations || !newVal) {
                    this.$emit('validatePriceGroupDecomposition', false);
                    return;
                }

                let isValid = false;

                for (const groupPrice of configurations) {
                    for (const priceConfig of newVal) {
                        isValid = priceConfig.productGenderPriceComponents.some(priceComponent =>
                            priceComponent.isRemainingValue && (groupPrice.price - Math.abs(priceComponent.value) < 0.1)
                        );

                        if (isValid) break;
                    }
                    if (isValid) break;
                }

                this.$emit('validatePriceGroupDecomposition', isValid);
            }
        }
    },
    created() {
        this.updateFlagsIfEventEdit();
        this.setGroupPrices(this.prices);
        this.debouncedUpdatePeopleNumber = _.debounce(this.updatePeoplesNumber, 1000);
        this.initState();
    },
    computed: {
        ...mapGetters([
            'getVatTypes',
            'getModal',
            'getAudienceTypeList',
            'getExtras'
        ]),
        pricePerGroupPrices() {
            const genderPrices = this.group.productGenderPrices || this.group.eventGenderPrices || [];
            const { passengerSettings } = this.group;

            if (passengerSettings.format !== 2) {
                return passengerSettings.configurations || [];
            }

            const selectedGenderPrice = genderPrices.find(gp => gp.hashedAudience === this.selectedHash);

            if (!selectedGenderPrice || !Array.isArray(selectedGenderPrice.tieredConfigurations) || selectedGenderPrice.tieredConfigurations.length === 0) {
                const newConfig = {
                    lowerBound: 1,
                    upperBound: null,
                    vat: 0,
                    price: 0
                }

                selectedGenderPrice.tieredConfigurations = [JSON.parse(JSON.stringify(newConfig))];
            }

            return selectedGenderPrice.tieredConfigurations;
        },
        maxLimit() {
            if (!this.group) return 0;

            const UNLIMITED = Infinity;

            switch (this.group.availabilityType) {
                case 0:
                    return this.group.capacity || this.group.maximumLotation || 0;
                case 1:
                    return UNLIMITED;
                case 2:
                    const resources = Array.isArray(this.group.resources)
                        ? this.group.resources
                        : Array.isArray(this.group.eventResources)
                        ? this.group.eventResources
                        : [];
                    return resources.reduce((acc, r) => acc + (r.maxSeats || 0), 0);
                default:
                    return 0;
            }
        },
        taxes() {
            return this.getVatTypes;
        },
        audienceTypes() {
            return this.getAudienceTypeList.filter(audienceType => audienceType.id < 500);
        },
        hasOnlyOneGenderPrice() {
            const genderPrices = this.group.productGenderPrices || this.group.eventGenderPrices || [];

            return genderPrices.length > 1;
        },
        hasResources() {
            return this.group.resources.length > 0 || this.group.eventResources.length > 0;
        },
        hasPriceErrors() {
            if (!this.group || !this.group.passengerSettings || !Array.isArray(this.pricePerGroupPrices)) {
                return false;
            }

            return this.pricePerGroupPrices.some(
                config => config.lowerBound > this.maxLimit || config.upperBound > this.maxLimit
            );
        },
       priceErrorMessage() {
            if (!this.group) return "Invalid group data. Please check the settings.";

            const maxLimitValue = this.maxLimit || "Unknown";
            return `The maximum allowed capacity is ${maxLimitValue}. Please adjust the prices accordingly.`;
        },
        hasPriceErrorsDueResources() {
            const resources = Array.isArray(this.group.resources) ? this.group.resources 
                            : Array.isArray(this.group.eventResources) ? this.group.eventResources 
                            : [];

            return this.group.availabilityType === 2 && resources.length === 0;
        },
        resourcesPriceErrorMessage() {
            return `Your availability depends on resources, but none have been added. Please add at least one resource.`;
        },
        importantNote() {
            return `Note: The final upper bound must be left empty for the system to assume the maximum value.`;
        }
    },
    methods: {
        ...mapActions([
            'openModal',
            'updateroductEditPriceData',
            'setGroupPrices'
        ]),
        openLearnMoreModal() {
            this.openModal('PerGroupLearnMore');
        },
        initState() {
            const genderPrices = this.group.productGenderPrices || this.group.eventGenderPrices || [];
            const newConfig = {
                    lowerBound: 1,
                    upperBound: null,
                    vat: 0,
                    price: 0
                }

            if (this.group.passengerSettings.configurations === null) {
                this.group.passengerSettings.configurations = [];

                this.group.passengerSettings.configurations.push(JSON.parse(JSON.stringify(newConfig)));
            }

            this.initHash(genderPrices)
        },
        initHash(genderPrices) {
            this.selectedHash = genderPrices.length > 0 ? JSON.parse(JSON.stringify(genderPrices[0].hashedAudience)) : null;
        },
        changePriceType(newValue) {
            const genderPrices = this.group.productGenderPrices || this.group.eventGenderPrices || [];
            const newConfig = {
                    lowerBound: 1,
                    upperBound: null,
                    vat: 0,
                    price: 0
                }
            const formatMap = {
                2: 'PerCategoryTier',
                1: 'PerCategory',
                0: 'PerGroup'
            };

            this.group.passengerSettings.friendlyFormat = formatMap[newValue] || null;

            if (newValue === 2) {
                genderPrices.forEach(gp => {
                    if (!gp.tieredConfigurations) {
                        gp.tieredConfigurations = [JSON.parse(JSON.stringify(newConfig))];
                    }
                });
            } else {
                genderPrices.forEach(gp => {
                    gp.tieredConfigurations = null;
                });
            }
        },
        isTierPrice(genderPrice) {
            const genderPrices = this.group.productGenderPrices || this.group.eventGenderPrices || [];

            return genderPrices.some(prices => prices.audienceType === genderPrice.id);
        },
        isSameHash(gender) {
            const genderPrices = this.group.productGenderPrices || this.group.eventGenderPrices || [];

            const genderPrice = genderPrices.find(gp => gp.audienceType === gender.id)

            if (genderPrice) {
                return genderPrice.hashedAudience === this.selectedHash;
            } else {
                return false;
            }
        },
        activateCategoryPrices(gender) {
            const genderPrices = this.group.productGenderPrices || this.group.eventGenderPrices || [];

            const genderPrice = genderPrices.find(gp => gp.audienceType === gender.id)

            this.$set(this, 'selectedHash', genderPrice.hashedAudience);
        },
        moreThanAllowed(priceConfig, idx) {
            if (!this.group) return false;

            return priceConfig.lowerBound > this.maxLimit || priceConfig.upperBound > this.maxLimit;
        },
        hasPriceDependencies(genderPriceDep) {
            const genderPrices = this.group.productGenderPrices || this.group.eventGenderPrices || [];
            const gp = genderPrices.find(g => g.audienceType === genderPriceDep.id);
            const priceDependencies = gp && Array.isArray(gp.genderPriceDependencies) ? gp.genderPriceDependencies : [];

            return priceDependencies.length > 0 && priceDependencies.some(dependency => dependency.isDeleted === false);        
        },
        openGenderPriceDeps(priceRow) {
            if (this.disabled && !this.hasPriceDependencies(priceRow)) return;

            const genderPrice = this.prices.find(price => price.audienceType === priceRow.id);
            
            genderPrice.isDisabled = this.disabled;
            this.updateroductEditPriceData(genderPrice);
            this.updateFlagsIfEventEdit();
            
            this.openModal({
                name: 'GenderPricesDependencies',
                callback: () => {}
            });
            
        },
        openEditPrice() {
            if ((this.disabled && !this.hasDecomposedPrices) || this.hasPriceErrorsDueResources) {
                return;
            }

            if (this.getExtras.length === 0) {
                this.noServicesErrorMessage();
                
                return;
            }

            const genderPricesToEdit = this.group.productGenderPrices || this.group.eventGenderPrices || [];

            genderPricesToEdit[0].isDisabled = this.disabled;
            genderPricesToEdit[0].isPricePerGroup = true;

            this.updateroductEditPriceData(genderPricesToEdit[0]);
            this.updateFlagsIfEventEdit();
            
            this.openModal({
                name: 'ProductEditPrice',
                callback: () => {
                    const genderPrices = this.group.productGenderPrices || this.group.eventGenderPrices || [];
                    const {componentRuleType, productGenderPriceComponents} = genderPrices[0];
                    
                    genderPrices.map(genderPrice => {
                        genderPrice.componentRuleType = componentRuleType;
                        genderPrice.productGenderPriceComponents = productGenderPriceComponents;
                    })
                }
            });
        },
        addPriceConfig() {
            if (this.disabled || this.hasPriceErrorsDueResources) {
                return;
            }

            const genderPrices = this.group.productGenderPrices || this.group.eventGenderPrices || [];
            const configs = this.pricePerGroupPrices;
            const lastConfig = configs[configs.length - 1];
            
            let nextLowerBound = 1;

            if (lastConfig) {
                lastConfig.upperBound = Number(lastConfig.lowerBound + 1);
                nextLowerBound = Number(lastConfig.upperBound + 1);
            }

            const newConfig = {
                lowerBound: nextLowerBound,
                upperBound: null,
                vat: 0,
                price: 0
            };

            if (this.group.passengerSettings.format !== 2) {
                if (!this.group.passengerSettings.configurations) {
                    this.group.passengerSettings.configurations = [];
                }

                this.group.passengerSettings.configurations.push(JSON.parse(JSON.stringify(newConfig)));
            } else {
                const targetGenderPrice = genderPrices.find(gp => gp.hashedAudience === this.selectedHash);
                
                if (targetGenderPrice) {
                    if (!targetGenderPrice.tieredConfigurations) {
                        targetGenderPrice.tieredConfigurations = [];
                    }
                    targetGenderPrice.tieredConfigurations.push(JSON.parse(JSON.stringify(newConfig)));
                }
            }
        },
        removePriceConfig(idx) {
            if (this.disabled || this.hasPriceErrorsDueResources) {
                return;
            }

            this.pricePerGroupPrices.splice(idx, 1);
            this.organizePriceConfigurations(this.pricePerGroupPrices);
        },
        organizePriceConfigurations(configs) {
            if (configs.length === 0) {
                return configs;
            }
            
            // When only one price config
            if (configs.length === 1) {
                configs[0].lowerBound = 1;
                configs[0].upperBound = null;

                return configs;
            }

            // First object lower bound always 1
            configs[0].lowerBound = 1;

            // Ensure the second object's lowerBound = first object's upperBound + 1. Aim for consistency between consecutive objects.
            for (let i = 1; i < configs.length; i++) {
                const prev = configs[i - 1];
                const current = configs[i];
                
                // Set current.lowerBound to be prev.upperBound + 1
                current.lowerBound = prev.upperBound + 1;

                // If the current upperBound is smaller than the lowerBound, adjust it
                if (current.upperBound <= current.lowerBound) {
                    current.upperBound = current.lowerBound + 1;
                }

                if (configs.length - 1 === i) {
                    current.upperBound = null
                }
            }

            return configs;
        },
        updatePeoplesNumber(idx, newUpperBound) {
            const configs = this.pricePerGroupPrices;

            if (isNaN(newUpperBound)) {
                this.pricePerGroupPrices[idx].upperBound = null;
                
                return;
            } 

            if (idx === configs.length - 1) {
                if (newUpperBound > this.maxLimit) {
                    return;
                } else if (newUpperBound === this.maxLimit) {
                    this.pricePerGroupPrices[idx].upperBound = null;
                    
                    return;
                } else {
                    this.addPriceConfig();
                }
            }

            // Save typed value
            const currentConf = configs[idx];

            // Convert to number
            const convertedValue = Number(newUpperBound);
            if (!isNaN(convertedValue)) {
                currentConf.upperBound = convertedValue;
            }
            
            // Now we run the cycle to correct from idx+1 to the end
            for (let i = idx + 1; i < configs.length; i++) {
                const atualConf = configs[i - 1];
                const nextConf = configs[i];
                
                if (atualConf.upperBound < atualConf.lowerBound) {
                    atualConf.upperBound = Number(atualConf.lowerBound);
                }
                
                nextConf.lowerBound = Number(atualConf.upperBound + 1);

                if ((typeof nextConf.upperBound !== 'number' || nextConf.upperBound <= nextConf.lowerBound) && i !== configs.length-1) {
                    nextConf.upperBound = Number(nextConf.lowerBound + 1);
                } else if (i === configs.length-1) {
                    nextConf.upperBound = null;
                }
            }
        },
        getTaxValue(vat) {
            return this.getVatTypes.find(vats => vats.id === vat);
        },
        getAudienceTypeCheckboxValue(audienceType) {
            const genderPrices = this.group.productGenderPrices || this.group.eventGenderPrices || [];
            
            return genderPrices.some(prices => prices.audienceType === audienceType.id);
        },
        updateAudienceTypeCheckbox(event, genderPrice) {
            const genderPrices = this.group.productGenderPrices || this.group.eventGenderPrices || [];
            const { componentRuleType, productGenderPriceComponents } = genderPrices[0];
            const newConfig = {
                    lowerBound: 1,
                    upperBound: null,
                    vat: 0,
                    price: 0
                }
                        
            if (event.target.checked) {
                const newGenderPrice = {
                    id: 0,
                    genderPriceType: 3,
                    hashedAudience: genderPrice.id,
                    audienceType: genderPrice.id,
                    audienceTypeGroup: null,
                    audienceTypeDescription: genderPrice.description,
                    dependencySettings: null,
                    genderPriceDependencies: [],
                    componentRuleType: componentRuleType || null,
                    productGenderPriceComponents: productGenderPriceComponents || [],
                    tieredConfigurations: this.group.passengerSettings.format === 2 ? [ newConfig ] : null
                }
                
                genderPrices.push(newGenderPrice)
            } else {
                const index = genderPrices.findIndex(prices => 
                    prices.audienceType === genderPrice.id && 
                    prices.audienceTypeDescription === genderPrice.description
                );

                if (index !== -1) {
                    genderPrices.splice(index, 1);
                }

               this.selectedHash = genderPrices.length ? genderPrices[0].hashedAudience : null;
            }

            this.setGroupPrices(genderPrices);
        },
        validateGenderPriceDeps(genderPrice) {
            const genderPrices = this.group.productGenderPrices || this.group.eventGenderPrices || [];

            return genderPrices.length > 1 && genderPrices.some(prices => prices.audienceType === genderPrice.id);
        },
        hasPriceGroupDecompositionError(rowPrice){
            const genderPrices = this.group.productGenderPrices || this.group.eventGenderPrices || [];
            const {componentRuleType, productGenderPriceComponents} = genderPrices[0];
            const groupPrice = rowPrice.price;

            const listOfValuesOfGrossprices = productGenderPriceComponents.map(service => !service.isRemainingValue && service.component.selectedPrice != null ? parseFloat(service.component.selectedPrice.grossprice) : 0);
            const sumGrossprices = listOfValuesOfGrossprices.length > 0 ? listOfValuesOfGrossprices.reduce((accumulator, currentValue) => accumulator + currentValue, 0) : 0;

            return productGenderPriceComponents.some(priceComponent => (groupPrice - sumGrossprices) < 0.1 && priceComponent.isRemainingValue);
        },
        priceConfigInfo(rowPrice) {
            const genderPrices = this.group.productGenderPrices || this.group.eventGenderPrices || [];
            const {componentRuleType, productGenderPriceComponents} = genderPrices[0];
            const groupPrice = rowPrice.price;

            let content = `
                <div class="border rounded p-1 my-1">
                    <h5 class="pb-0 mb-2 m-2 border-0">Decomposed Prices</h5>
                    <div class="d-flex mb-1 mt-1 m-2">
                        <table class="table narrow mt-2">
                            <thead>
                                <tr>
                                    <th style="width: 55%;" class="fs-smaller text-center">Service</th>
                                    <th style="width: 10%;" class="fs-smaller text-center">Tax</th>`;

            if (componentRuleType === 1) {
                content += `<th style="width: 10%;" class="pl-3 fs-smaller text-center">Percent</th>`;
            }

            content += `<th style="width: 25%;" class="pl-3 fs-smaller text-center">PVP</th>
                                </tr>
                            </thead>
                            <tbody>`;

            productGenderPriceComponents.forEach((priceComponent) => {
                const listOfValuesOfGrossprices = productGenderPriceComponents.map(service => !service.isRemainingValue && service.component.selectedPrice != null ? parseFloat(service.component.selectedPrice.grossprice) : 0);
                const sumGrossprices = listOfValuesOfGrossprices.length > 0 ? listOfValuesOfGrossprices.reduce((accumulator, currentValue) => accumulator + currentValue, 0) : 0;

                content += (groupPrice - sumGrossprices < 0.1 && priceComponent.isRemainingValue) ? `<tr class="noHover more-than-allowed">` : `<tr class="noHover">`;

                content += `<td class="fs-smaller pl-2">${priceComponent.component.name}</td>
                            <td class="fs-smaller text-center">${priceComponent.component.vatType} %</td>`;

                if (componentRuleType === 1) {
                    content += `
                        <td class="pl-3 fs-smaller text-center">${priceComponent.value} %</td>
                        <td class="pl-3 fs-smaller text-center">${this.formatPrice((priceComponent.value / 100) * groupPrice)} €</td>`;
                } else {
                    const value = priceComponent.isRemainingValue
                        ? groupPrice - sumGrossprices
                        : priceComponent.value;

                    content += `<td class="pl-3 fs-smaller text-center">${value} €</td>`;
                }

                content += `</tr>`;
            });

            content += `
                <tr class="noHover">
                    <td class="fs-smaller pl-2"></td>
                    <td class="fs-smaller text-center"></td>`;

            if (componentRuleType === 1) {
                content += `<td class="pl-3 fs-smaller text-center"></td>`;
            }

            content += `<td class="pl-3 fs-smaller text-center">${this.formatPrice(groupPrice)} €</td>
                    </tr>
                </tbody>
                </table>
                </div>`
            if (this.hasPriceGroupDecompositionError(rowPrice)) {
                content += `
                    <div class="d-flex justify-content-center error">
                        <span class="fs-smaller">The service value cannot be equal to or less than 0€</span> 
                    </div>`;
            }
                
            content += `</div>`;

            return {
                content: content,
                classes: ['size'],
                show: false
            };
        },
        updateTaxVal(event, priceConfig) {
            priceConfig.vat = event.id;
        },
        updateFlagsIfEventEdit() {
            // Adding a updateflag to Prices on editEvent | mixin.js
            if (this.editingEvent) this.eventActivateUpdateFlag('Prices');
        }
    },
    components: {
        vSelect: extendedVSelect,
    }
}
</script>

<style lang="scss" scoped>
    .size {
        min-width: 400px;
    }

    .thead-size {
        height: 40px;
    }

    .table {
        tbody tr:hover {
            border: none;
            transform: none;
            background-color: #ffffff;
        }

        tbody tr:hover.more-than-allowed {
            border: none;
            transform: none;
            background-color: #ffe5e5;
        } 
    }

    .w-80 {
        width: 80%;
    }

    .default-cursor {
        cursor: default;
    }

    .check-icon-position {
        position: relative;
        bottom: 0.3rem;
        right: 1.16rem;
        background-color: #fff;
        border-radius: 15px;
    }

    .btn-learn-more {
        background: none;
        border: none;
        color: #00a9f0;
        text-decoration: underline;

        &:hover {
            color: #0084bc;
        }
    }
</style>

<style lang="scss">
    .ppg-smaller-select {
        .dropdown-toggle {
            height: 30px !important;

            .vs__actions {
                top: 3px !important;
            }

            .selected-tag, & input[type=search] {
                height: 28px !important;
                margin: 0 !important;
                line-height: 1.4rem !important;
                font-size: 11px !important;
            }
        }
        
        .dropdown-menu {
            font-size: 11px !important;
            color: black;
            height: 130px !important;
            position: absolute !important;
            
            li[role=option] a {
                padding-left: 15px !important;
            }
        }

        .open-indicator {
            height: 20px !important;
        }
    }

    .more-than-allowed {
        background-color: #ffe5e5;
    }
</style>



// WEBPACK FOOTER //
// PricePerGroup.vue?2149919a